import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { QueryParamService } from '../../shared/core/ovs.core';
import { RoomFilterCommon } from '../room-availability-v2/room-filter.common';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'room-filter-mobile',
  templateUrl: './room-filter-mobile.component.html',
  styleUrls: ['./room-filter-mobile.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class RoomFilterMobileComponent extends RoomFilterCommon implements OnInit {
  constructor(
   qryParamService: QueryParamService
  ){ 
    super();
    this.qryParamService = qryParamService;
    this.initialize();
  }

  public monthDateSelected: Date;

  ngOnInit() {
    this.monthDateSelected = this.ngbDateToDate(this.selectedDate);
    this.onSelectedDateChanged(this.selectedDate);
  }
   
  public get selectedNightsLabel(): string{
    let label: string;
    if(this.roomFilter && this.roomFilter.nights)
    this.roomFilter.nights.where(n => n.isSelected).toArray().forEach(
      n => {
        if(label) label = label +", "+ n.value;
        else label = n.value.toString();
      }
    );
    return label;
  }

  public get selectedRoomTypesLabel(): string{
    if(this.roomFilter && this.roomFilter.unitTypes)
        return this.roomFilter.unitTypes.where(r => r.isSelected).count().toString();
    else
        return "";
    }

  public resetFilters(): void {
      this.roomFilter.unitTypes.forEach(n => n.isSelected = true);
      this.roomFilter.nights.forEach(n => n.isSelected = true);
      this.selectedPrice = this.roomFilter.maxPrice;
      this.filterUpdated.emit(this.currentRoomFilter);
  }

  public selectedDateChanged(date){
    this.selectedDate = this.dateToNgbDate(date);
    this.monthDateSelected = date;
    this.onSelectedDateChanged(this.selectedDate);
  }

  private dateToNgbDate(date: Date) {
    return <NgbDateStruct>{ year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() };
  }

  private ngbDateToDate(date: NgbDateStruct) {
    return new Date(date.year, date.month - 1, date.day);
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/room-availability/room-filter-mobile/room-filter-mobile.component.ts